export const infoOutputFileName = "info.json";
